import React, { useEffect, useState } from "react";
import ApprovePopup from "./ApprovePopup";
import { AiOutlineNodeExpand } from "react-icons/ai";
import axios from "axios";
import { FallingLines } from "react-loader-spinner";
import { LuPanelLeftOpen, LuPanelRightOpen } from "react-icons/lu";
import { base_url } from "../../../utils/AxiosConfig";
import { FaSearch } from "react-icons/fa";
import dayjs from "dayjs";

import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 0 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

// function BasicTabs() {
// const [value, setValue] = useState(0);

// const handleChange = (event, newValue) => {
//   setValue(newValue);
// };

// }

const LeaveApproval = () => {
  const storedUserDataArray =
    JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
  let companyCode = null;

  if (storedUserDataArray) {
    companyCode = storedUserDataArray[0].cmpcode;
  }

  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const [Open, setOpen] = useState(false);
  const [DataPending, setDataPending] = useState();
  const [DataApproved, setDataApproved] = useState();
  const [DataRejected, setDataRejected] = useState();
  const [PopUpData, setPopUpData] = useState();
  const [SearchData, setSearchData] = useState();
  const [SearchDataApproved, setSearchDataApproved] = useState();
  const [SearchDataRejected, setSearchDataRejected] = useState();
  const [loader, setLoader] = useState(true);
  const [reloadapiData, setReloadApi] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  // pagination
  const [currentPage, SetcurrentPage] = useState(1);
  const [currentPageApproved, SetcurrentPageApproved] = useState(1);
  const [currentPageRejected, SetcurrentPageRejected] = useState(1);
  const recordsPerPage = 10;

  const lastIndex = currentPage * recordsPerPage;
  const firstIndex = lastIndex - recordsPerPage;

  const lastIndexApproved = currentPageApproved * recordsPerPage;
  const firstIndexApproved = lastIndexApproved - recordsPerPage;

  const lastIndexRejected = currentPageRejected * recordsPerPage;
  const firstIndexRejected = lastIndexRejected - recordsPerPage;

  const dataPendingrecords = DataPending?.slice(firstIndex, lastIndex);
  const dataApprovedrecords = DataApproved?.slice(
    firstIndexApproved,
    lastIndexApproved,
  );
  const dataRejectedrecords = DataRejected?.slice(
    firstIndexRejected,
    lastIndexRejected,
  );

  const npage = Math.ceil(DataPending?.length / recordsPerPage);
  const npageApproved = Math.ceil(DataApproved?.length / recordsPerPage);
  const npageRejected = Math.ceil(DataRejected?.length / recordsPerPage);

  const numbers = Array.from({ length: npage }, (_, i) => i + 1);
  const numbersApproved = Array.from(
    { length: npageApproved },
    (_, i) => i + 1,
  );
  const numbersRejected = Array.from(
    { length: npageRejected },
    (_, i) => i + 1,
  );

  useEffect(() => {
    if (DataPending && DataApproved === null) {
      setLoader(true);
    } else if (DataRejected && DataPending && DataApproved) {
      setLoader(false);
    }
  }, [DataPending, DataApproved, DataRejected]);
  useEffect(() => {
    const getDataPending = async () => {
      const response = await axios.get(
        `${base_url}/api/PersonalInfoLeaveApplicationList/${companyCode}/PENDING/-`,
      );
      if (response?.data) {
        setDataPending(response.data);
      } else {
        console.log("error");
      }
    };

    getDataPending();
  }, []);

  useEffect(() => {
    const getDataApproved = async () => {
      const response = await axios.get(
        `${base_url}/api/PersonalInfoLeaveApplicationList/${companyCode}/APPROVED/-`,
      );
      if (response?.data) {
        setDataApproved(response.data);
      } else {
        console.log("error");
      }
    };

    getDataApproved();
  }, []);

  useEffect(() => {
    const getDataRejected = async () => {
      const response = await axios.get(
        `${base_url}/api/PersonalInfoLeaveApplicationList/${companyCode}/REJECTED/-`,
      );
      if (response?.data) {
        setDataRejected(response.data);
      } else {
        console.log("error");
      }
    };

    getDataRejected();
  }, []);

  useEffect(() => {
    const getSearch = async () => {
      const response = await axios.get(
        `${base_url}/api/PersonalInfoLeaveApplicationList/${companyCode}/PENDING/${
          SearchData ? SearchData : "-"
        }`,
      );
      if (response?.data) {
        setDataPending(response.data);
      } else {
        console.log("error");
      }
    };

    getSearch();
  }, [SearchData]);

  useEffect(() => {
    const getSearchDataApproved = async () => {
      const response = await axios.get(
        `${base_url}/api/PersonalInfoLeaveApplicationList/${companyCode}/APPROVED/${
          SearchDataApproved ? SearchDataApproved : "-"
        }`,
      );
      if (response?.data) {
        setDataApproved(response.data);
      } else {
        console.log("error");
      }
    };

    getSearchDataApproved();
  }, [SearchDataApproved]);

  useEffect(() => {
    const getSearchDataRejected = async () => {
      const response = await axios.get(
        `${base_url}/api/PersonalInfoLeaveApplicationList/${companyCode}/REJECTED/${
          SearchDataRejected ? SearchDataRejected : "-"
        }`,
      );
      if (response?.data) {
        setDataRejected(response.data);
      } else {
        console.log("error");
      }
    };

    getSearchDataRejected();
  }, [SearchDataRejected]);

  const reloadApi = (status) => {
    setReloadApi(status);
  };

  useEffect(() => {
    const getDataPending = async () => {
      const response = await axios.get(
        `${base_url}/api/PersonalInfoLeaveApplicationList/${companyCode}/PENDING/-`,
      );
      if (response?.data) {
        setDataPending(response.data);
        setReloadApi(false);
      } else {
        console.log("error");
      }
    };
    if (reloadapiData && SearchData === null) {
      getDataPending();
    }
  }, [reloadapiData]);

  useEffect(() => {
    const getDataApproved = async () => {
      const response = await axios.get(
        `${base_url}/api/PersonalInfoLeaveApplicationList/${companyCode}/APPROVED/-`,
      );
      if (response?.data) {
        setDataApproved(response.data);
      } else {
        console.log("error");
      }
    };

    if (reloadapiData && SearchDataApproved === null) {
      getDataApproved();
    }
  }, [reloadapiData]);

  useEffect(() => {
    const getDataRejected = async () => {
      const response = await axios.get(
        `${base_url}/api/PersonalInfoLeaveApplicationList/${companyCode}/REJECTED/-`,
      );
      if (response?.data) {
        setDataRejected(response.data);
      } else {
        console.log("error");
      }
    };
    if (reloadapiData && SearchDataRejected === null) {
      getDataRejected();
    }
  }, [reloadapiData]);

  useEffect(() => {
    const getDataPending = async () => {
      const response = await axios.get(
        `${base_url}/api/PersonalInfoLeaveApplicationList/${companyCode}/PENDING/-`,
      );
      if (response?.data) {
        setDataPending(response.data);
        setReloadApi(false);
      } else {
        console.log("error");
      }
    };
    if (reloadapiData) {
      getDataPending();
    }
  }, [reloadapiData]);

  useEffect(() => {
    const getDataApproved = async () => {
      const response = await axios.get(
        `${base_url}/api/PersonalInfoLeaveApplicationList/${companyCode}/APPROVED/-`,
      );
      if (response?.data) {
        setDataApproved(response.data);
      } else {
        console.log("error");
      }
    };

    if (reloadapiData) {
      getDataApproved();
    }
  }, [reloadapiData]);

  useEffect(() => {
    const getDataRejected = async () => {
      const response = await axios.get(
        `${base_url}/api/PersonalInfoLeaveApplicationList/${companyCode}/REJECTED/-`,
      );
      if (response?.data) {
        setDataRejected(response.data);
      } else {
        console.log("error");
      }
    };
    if (reloadapiData) {
      getDataRejected();
    }
  }, [reloadapiData]);

  // console.log('reloadapiData',reloadapiData)
  console.log("DataApproved", DataApproved);

  return (
    <div className="container">
      <div
        className={
          Open ? "leave-allotment container-fluid ps-2" : "container-fluid ps-2"
        }
      >
        <div className="flex items-center justify-between mb-4 ">
          {/* <div className="">
            <h6 className=" text-2xl font-bold text-gray-600 flex  justify-start items-center">
              Leave Approval
            </h6>
          </div> */}
          <div className="flex justify-left items-center ">
            <div className="w-1 h-8 bg-gradient-to-r from-[#2663EB] to-blue-400 rounded-full  mr-2"></div>
            <h6 className="text-xl font-bold text-gray-900 flex items-center gap-4">
              {/* <span className="inline-flex items-center justify-center w-12 h-12 rounded-xl bg-gradient-to-br from-[#2663EB] to-blue-700 text-white shadow-lg">
      <MdPersonAddAlt className="w-7 h-7" />
      </span> */}
              <span className="bg-gradient-to-r from-[#2663EB] to-blue-600 bg-clip-text text-transparent">
                LEAVE APPROVAL
              </span>
            </h6>
          </div>

          <div className="w-full max-w-sm">
            <div className="flex items-center gap-2 px-4 py-2 bg-white border border-gray-200 rounded-xl shadow-sm transition-all duration-200 focus-within:border-[#2663EB] focus-within:ring-2 focus-within:ring-[#2663EB]/20 hover:shadow-md">
              <FaSearch className="text-gray-400 text-sm transition-colors duration-200 group-focus-within:text-[#2663EB]" />

              <input
                type="text"
                placeholder="Search Employee..."
                value={SearchData}
                onChange={(e) => setSearchData(e.target.value)}
                className="w-full bg-transparent outline-none text-sm text-gray-700 placeholder-gray-400"
              />

              {SearchData && (
                <button
                  onClick={() => setSearchData("")}
                  className="text-gray-400 hover:text-red-500 text-sm transition-colors"
                >
                  ✕
                </button>
              )}
            </div>
          </div>

          <div className="">
            {Open === true ? (
              <>
                <LuPanelRightOpen onClick={() => setOpen(false)} />
              </>
            ) : null}
            {Open === false ? (
              <>
                <LuPanelLeftOpen onClick={() => setOpen(true)} />
              </>
            ) : null}
          </div>
        </div>
        {dataPendingrecords ? (
          <>
            <div>
              <div className="leave-application-table mt-2">
                <p className="fs-small text-secondary mb-2">
                  Leave Request For Approval
                </p>

                {/* <div
                  className={Open ? "table scroll" : "table scroll"}
                  style={{ height: "auto" }}
                > */}
                <div>
                  {/* <table class="table "> */}
                  <table className="shadow-sm min-w-full bg-white rounded-sm border border-gray-300 text-xs mb-2">
                    <thead>
                      <tr className="bg-[#2663EB] text-white">
                        <th className="px-2 py-1 border-none font-normal">
                          Sl No
                        </th>
                        <th className="px-2 py-1 border-none font-normal">
                          Name
                        </th>
                        <th className="px-2 py-1 border-none font-normal">
                          Leave Category
                        </th>
                        <th className="px-2 py-1 border-none font-normal">
                          Application Date
                        </th>
                        <th className="px-2 py-1 border-none font-normal">
                          Leave From
                        </th>
                        <th className="px-2 py-1 border-none font-normal">
                          Leave To
                        </th>
                        <th className="px-2 py-1 border-none font-normal">
                          Total Days
                        </th>

                        {Open ? (
                          <>
                            {/* <th className="px-2 py-1 border-none">Approved By</td>
                          <th className="px-2 py-1 border-none">Approval Date</td>
                          <td>Rejoin Date</td> */}

                            <th className="px-2 py-1 border-none font-normal">
                              Serialcode
                            </th>
                          </>
                        ) : null}
                        <th className="px-2 py-1 border-none font-normal text-center">
                          Actions
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {dataPendingrecords
                        ? dataPendingrecords?.map((d, i) => (
                            // <tr className="dataTr">
                            <tr className="">
                              <td className="px-2 py-1 border">{i + 1}</td>
                              <td className="px-2 py-1 border">{d.Name}</td>
                              <td className="px-2 py-1 border">
                                {d.Leave_Category}
                              </td>

                              <td className="px-2 py-1 border">
                                {dayjs(d?.ApplicationDate).format("YYYY-MM-DD")}
                              </td>
                              <td className="px-2 py-1 border">
                                {dayjs(d?.FromDate).format("YYYY-MM-DD")}
                              </td>
                              <td className="px-2 py-1 border">
                                {dayjs(d?.ToDate).format("YYYY-MM-DD")}
                              </td>

                              <td className="px-2 py-1 border text-right">
                                {d.Days}
                              </td>
                              {/* <td><input type="text" className="form-control"/></td> */}

                              {Open ? (
                                <>
                                  {/* <td className="px-2 py-1 border">{d.ApprovedBy}</td> */}
                                  {/* <td className="px-2 py-1 border">{d.ApprovalDate}</td>
                                <td className="px-2 py-1 border">{d.RejoinDate}</td> */}
                                  <td className="px-2 py-1 border">
                                    {d.Serialcode}
                                  </td>
                                </>
                              ) : null}

                              <td className="px-2 py-1 border text-center">
                                {/* <button
                                // className="dash-btn"
                      className="bg-green-500 px-2 py-1 border rounded-lg text-white font-semibold"

                                data-bs-toggle="modal"
                                data-bs-target="#exampleModal"
                                onClick={() => setPopUpData(d)}
                              >
                                Approve
                              </button> */}

                                <button
                                  className="bg-green-500 hover:bg-green-600 px-2 py-1 rounded-lg text-white font-semibold shadow-sm transition-all duration-200"
                                  onClick={() => {
                                    setPopUpData(d);
                                    setIsModalOpen(true);
                                  }}
                                >
                                  Approve
                                </button>
                              </td>
                            </tr>
                          ))
                        : null}
                    </tbody>
                  </table>
                </div>
                {dataPendingrecords ? (
                  <>
                    <div className="pagination-div">
                      <div className="text-end">
                        <nav aria-label="Page navigation example">
                          <ul class="pagination">
                            <li class="page-item">
                              {currentPage !== 1 ? (
                                <button
                                  class="page-link"
                                  href="#"
                                  onClick={prePage}
                                >
                                  Previous
                                </button>
                              ) : (
                                ""
                              )}
                            </li>
                            {numbers.map((n, i) => (
                              <li
                                className={`page-item ${
                                  currentPage === n ? "active" : ""
                                }`}
                                key={i}
                              >
                                <button
                                  className="page-link"
                                  onClick={() => changeCPage(n)}
                                  href="#"
                                >
                                  {n}
                                </button>
                              </li>
                            ))}

                            <li class="page-item">
                              {currentPage !== numbers[numbers.length - 1] ? (
                                <button
                                  class="page-link"
                                  href="#"
                                  onClick={nextPage}
                                >
                                  Next
                                </button>
                              ) : null}
                            </li>
                          </ul>
                        </nav>
                      </div>
                    </div>
                  </>
                ) : null}
              </div>
            </div>
          </>
        ) : null}
      </div>

      <div className="mt-12">
        {/* <Box sx={{ width: "100%" }}> */}
        {/* <Box sx={{ borderBottom: 1, borderColor: "divider" }}> */}
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
        >
          <Tab label=" Leave Approved List" {...a11yProps(0)} />
          <Tab label="Leave Rejected List" {...a11yProps(1)} />
        </Tabs>
        {/* </Box> */}
        <CustomTabPanel value={value} index={0} sx={{ p: 0 }}>
          <div
            class="tab-pane fade show active"
            id="home-tab-pane"
            role="tabpanel"
            aria-labelledby="home-tab"
            tabindex="0"
          >
            <div
              className=" mt-4 p-0 scroll"
              style={{ height: "auto", maxHeight: "450px" }}
            >
              {/* <p className="fs-small text-secondary">Leave Rejected List</p> */}
              <div className="row">
                <div className="col-3">
                  {/* <div className="EmpList-search-container">
                      <FaSearch className="EmpList-search-icon" />
                      <input
                        type="text"
                        placeholder="Search"
                        className="EmpList-search-input"
                        onChange={(e) => setSearchDataApproved(e.target.value)}
                      />
                    </div> */}
                  <div className="w-full max-w-sm">
                    <div className="flex items-center gap-2 px-4 py-2 bg-white border border-gray-200 rounded-xl shadow-sm transition-all duration-200 focus-within:border-[#2663EB] focus-within:ring-2 focus-within:ring-[#2663EB]/20 hover:shadow-md">
                      <FaSearch className="text-gray-400 text-sm transition-colors duration-200 group-focus-within:text-[#2663EB]" />

                      <input
                        type="text"
                        placeholder="Search Employee..."
                        value={SearchDataApproved}
                        onChange={(e) => setSearchDataApproved(e.target.value)}
                        className="w-full bg-transparent outline-none text-sm text-gray-700 placeholder-gray-400"
                      />

                      {SearchDataApproved && (
                        <button
                          onClick={() => setSearchDataApproved("")}
                          className="text-gray-400 hover:text-red-500 text-sm transition-colors"
                        >
                          ✕
                        </button>
                      )}
                    </div>
                  </div>

                  {/* <input
                          type="text"
                          className="form-control fs-small mb-2"
                          placeholder="Search Here"
                          onChange={(e) =>
                            setSearchDataApproved(e.target.value)
                          }
                        /> */}
                </div>
              </div>
              {/* <table class="table"> */}
              <table className="mt-4 shadow-sm min-w-full bg-white rounded-sm border border-gray-300 text-xs ">
                <thead>
                  <tr className="bg-[#2663EB] text-white">
                    <th className="px-2 py-1 border-none font-normal">Sl No</th>
                    <th className="px-2 py-1 border-none font-normal">Name</th>
                    <th className="px-2 py-1 border-none font-normal">
                      Leave Category
                    </th>
                    <th className="px-2 py-1 border-none font-normal">
                      Application Date
                    </th>
                    <th className="px-2 py-1 border-none font-normal">
                      Leave From
                    </th>
                    <th className="px-2 py-1 border-none font-normal">
                      Leave To
                    </th>
                    <th className="px-2 py-1 border-none font-normal">
                      Total Days
                    </th>
                    <th className="px-2 py-1 border-none font-normal">Notes</th>
                    <th className="px-2 py-1 border-none font-normal">
                      Ticket Status
                    </th>
                    <th className="px-2 py-1 border-none font-normal">
                      Approval Status
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {dataApprovedrecords
                    ? dataApprovedrecords?.map((d, i) => (
                        <tr className="dataTr">
                          <td className="px-2 py-1 border">{i + 1}</td>
                          <td className="px-2 py-1 border">{d.Name}</td>
                          <td className="px-2 py-1 border">
                            {d.Leave_Category}
                          </td>

                          <td className="px-2 py-1 border">
                            {dayjs(d.ApplicationDate).format("YYYY-MM-DD")}
                          </td>
                          <td className="px-2 py-1 border">
                            {dayjs(d.FromDate).format("YYYY-MM-DD")}
                          </td>
                          <td className="px-2 py-1 border">
                            {dayjs(d.ToDate).format("YYYY-MM-DD")}
                          </td>
                          <td className="px-2 py-1 border">{d.Days}</td>
                          <td className="px-2 py-1 border">{d.approvalnote}</td>
                          {/* <td className="px-2 py-1 border"><input type="text" className="form-control"/></td> */}
                          <td className="px-2 py-1 border">{d.Ticket}</td>
                          <td className="px-2 py-1 border">
                            {d.ApprovalStatus}
                          </td>
                        </tr>
                      ))
                    : null}
                </tbody>
              </table>
            </div>
            {dataApprovedrecords ? (
              <>
                <div className="pagination-div mt-6">
                  <div className="text-end">
                    <nav aria-label="Page navigation example">
                      <ul class="pagination">
                        <li class="page-item">
                          {currentPageApproved !== 1 ? (
                            <button
                              class="page-link"
                              href="#"
                              onClick={prePageApproved}
                            >
                              Previous
                            </button>
                          ) : (
                            ""
                          )}
                        </li>
                        {numbersApproved.map((n, i) => (
                          <li
                            className={`page-item ${
                              currentPageApproved === n ? "active" : ""
                            }`}
                            key={i}
                          >
                            <button
                              className="page-link"
                              onClick={() => changeCPageApproved(n)}
                              href="#"
                            >
                              {n}
                            </button>
                          </li>
                        ))}

                        <li class="page-item">
                          {currentPageApproved !==
                          numbersApproved[numbersApproved.length - 1] ? (
                            <button
                              class="page-link"
                              href="#"
                              onClick={nextPageApproved}
                            >
                              Next
                            </button>
                          ) : (
                            ""
                          )}
                        </li>
                      </ul>
                    </nav>
                  </div>
                </div>
              </>
            ) : null}
          </div>
        </CustomTabPanel>
        <CustomTabPanel value={value} index={1}>
          <div>
            <div className="w-full max-w-sm mt-4">
            <div className="flex items-center gap-2 px-4 py-2 bg-white border border-gray-200 rounded-xl shadow-sm transition-all duration-200 focus-within:border-[#2663EB] focus-within:ring-2 focus-within:ring-[#2663EB]/20 hover:shadow-md">
              <FaSearch className="text-gray-400 text-sm transition-colors duration-200 group-focus-within:text-[#2663EB]" />

              <input
                type="text"
                placeholder="Search Employee..."
                value={SearchDataRejected}
                        onChange={(e) => setSearchDataRejected(e.target.value)}
                className="w-full bg-transparent outline-none text-sm text-gray-700 placeholder-gray-400"
              />

              {SearchDataRejected && (
                <button
                  onClick={() => setSearchDataRejected("")}
                  className="text-gray-400 hover:text-red-500 text-sm transition-colors"
                >
                  ✕
                </button>
              )}
            </div>
          </div>
            <div>
              <table className="mt-4 shadow-sm min-w-full bg-white rounded-sm border border-gray-300 text-xs ">
                <thead>
                  <tr className="bg-[#2663EB] text-white">
                    <th className="px-2 py-1 border-none font-normal">Sl No</th>
                    <th className="px-2 py-1 border-none font-normal">Name</th>
                    <th className="px-2 py-1 border-none font-normal">
                      Leave Category
                    </th>
                    <th className="px-2 py-1 border-none font-normal">
                      Application Date
                    </th>
                    <th className="px-2 py-1 border-none font-normal">
                      Leave From
                    </th>
                    <th className="px-2 py-1 border-none font-normal">
                      Leave To
                    </th>
                    <th className="px-2 py-1 border-none font-normal">
                      Total Days
                    </th>
                    <th className="px-2 py-1 border-none font-normal">Notes</th>
                    <th className="px-2 py-1 border-none font-normal">
                      Ticket Status
                    </th>
                    <th className="px-2 py-1 border-none font-normal">
                      Approval Status
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {dataRejectedrecords
                    ? dataRejectedrecords?.map((d, i) => (
                        <tr className="dataTr">
                          <td className="px-2 py-1 border">{i + 1}</td>
                          <td className="px-2 py-1 border">{d.Name}</td>
                          <td className="px-2 py-1 border">
                            {d.Leave_Category}
                          </td>
                          <td className="px-2 py-1 border">
                            {dayjs(d.ApplicationDate).format("YYYY-MM-DD")}
                          </td>
                          <td className="px-2 py-1 border">
                            {dayjs(d.FromDate).format("YYYY-MM-DD")}
                          </td>
                          <td className="px-2 py-1 border">
                            {dayjs(d.ToDate).format("YYYY-MM-DD")}
                          </td>
                          <td className="px-2 py-1 border">{d.Days}</td>
                          <td className="px-2 py-1 border">{d.approvalnote}</td>
                          {/* <td className="px-2 py-1 border"><input type="text" className="form-control"/></td> */}
                          <td className="px-2 py-1 border">{d.Ticket}</td>
                          <td className="px-2 py-1 border">
                            {d.ApprovalStatus}
                          </td>
                        </tr>
                      ))
                    : null}
                </tbody>
              </table>
            </div>
            {dataRejectedrecords ? (
              <>
                <div className="pagination-div mt-6">
                  <div className="text-end">
                    <nav aria-label="Page navigation example">
                      <ul class="pagination">
                        <li class="page-item">
                          {currentPageRejected !== 1 ? (
                            <button
                              class="page-link"
                              href="#"
                              onClick={prePageRejected}
                            >
                              Previous
                            </button>
                          ) : (
                            ""
                          )}
                        </li>
                        {numbersRejected.map((n, i) => (
                          <li
                            className={`page-item ${
                              currentPageRejected === n ? "active" : ""
                            }`}
                            key={i}
                          >
                            <button
                              className="page-link"
                              onClick={() => changeCPageRejected(n)}
                              href="#"
                            >
                              {n}
                            </button>
                          </li>
                        ))}

                        <li class="page-item">
                          {currentPageRejected !==
                          numbersRejected[numbersRejected.length - 1] ? (
                            <button
                              class="page-link"
                              href="#"
                              onClick={nextPageRejected}
                            >
                              Next
                            </button>
                          ) : (
                            ""
                          )}
                        </li>
                      </ul>
                    </nav>
                  </div>
                </div>
              </>
            ) : null}
          </div>
        </CustomTabPanel>
        {/* <CustomTabPanel value={value} index={2}>
          Item Three
        </CustomTabPanel> */}
        {/* </Box> */}
      </div>

      {isModalOpen && (
        <ApprovePopup
          setIsModalOpen={setIsModalOpen}
          setPopUpData={setPopUpData}
          PopUpData={PopUpData}
          reloadApi={reloadApi}
          setReloadApi={setReloadApi}
        />
      )}
      <div className="table-nodata-img mtd">
        {loader ? (
          <>
            {" "}
            <div className="table-nodata-img">
              <div className="center">
                <p className="text-center pt-5">
                  Please Wait Loading Data... &nbsp;
                  <FallingLines />
                </p>
              </div>
            </div>
          </>
        ) : null}
      </div>
    </div>
  );

  // pending
  function prePage() {
    if (currentPage !== firstIndex) {
      SetcurrentPage(currentPage - 1);
    }
  }

  function changeCPage(id) {
    SetcurrentPage(id);
  }

  function nextPage() {
    if (currentPage !== lastIndex) {
      SetcurrentPage(currentPage + 1);
    }
  }

  // approved
  function prePageApproved() {
    if (currentPageApproved !== firstIndexApproved) {
      SetcurrentPageApproved(currentPageApproved - 1);
    }
  }

  function changeCPageApproved(id) {
    SetcurrentPageApproved(id);
  }

  function nextPageApproved() {
    if (currentPageApproved !== lastIndexApproved) {
      SetcurrentPageApproved(currentPageApproved + 1);
    }
  }

  // rejected
  function prePageRejected() {
    if (currentPageRejected !== firstIndexRejected) {
      SetcurrentPageRejected(currentPageRejected - 1);
    }
  }

  function changeCPageRejected(id) {
    SetcurrentPageRejected(id);
  }

  function nextPageRejected() {
    if (currentPageRejected !== lastIndexRejected) {
      SetcurrentPageRejected(currentPageRejected + 1);
    }
  }
};

export default LeaveApproval;
